"use strict";
/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export function isGzipFormat(data) {
  const view = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  return view.length >= 3 && view[0] === 31 && view[1] === 139 && view[2] === 8;
}
export async function decodeGzip(data, format, signal) {
  try {
    const decompressedStream = decodeGzipStream(
      data instanceof Response ? data : new Response(data),
      format,
      signal
    );
    return await new Response(decompressedStream).arrayBuffer();
  } catch {
    signal?.throwIfAborted();
    throw new Error(`Failed to decode ${format}`);
  }
}
export function decodeGzipStream(response, format, signal) {
  return response.body.pipeThrough(new DecompressionStream(format), {
    signal
  });
}
export async function maybeDecompressGzip(data) {
  let byteView;
  if (data instanceof ArrayBuffer) {
    byteView = new Uint8Array(data);
  } else {
    byteView = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  }
  if (isGzipFormat(byteView)) {
    return new Uint8Array(await decodeGzip(byteView, "gzip"));
  }
  return byteView;
}
